
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/button/button.component';
import { InputComponent } from '../../components/input/input.component';
import TYPES from '../../constants/types';
import { Router } from '@angular/router';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    InputComponent,
    TranslatePipe,
    MatDatepickerModule,
    MatInputModule
],
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  forgotForm: FormGroup;
  BUTTON_TYPES: any;
  INFO_SCREEN: any;
  emailControl: UntypedFormControl;  
  isRecoverButtonDisabled:boolean;

  private authService: AuthService = inject(AUTH_SERVICE);

  constructor(
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    
    this.emailControl = new UntypedFormControl('', [Validators.required, Validators.email]);
    
    this.forgotForm = this.formBuilder.group({
      email: this.emailControl,
    });

    this.isRecoverButtonDisabled = this.forgotForm.invalid;
    this.forgotForm.statusChanges.subscribe(
      (event => {
        this.isRecoverButtonDisabled = this.forgotForm.invalid;
      })
    );

    this.BUTTON_TYPES = TYPES.UI.BUTTON;
    this.INFO_SCREEN = TYPES.UI.INFO_SCREEN;

  }

  async requestReset() {
    if(!this.isFormInvalid()){ 
      const error = await this.authService.requestPasswordReset(
        this.forgotForm.value.email, 
      );

      if(error === null){
        this.router.navigate([
          '/info', 
          this.INFO_SCREEN.SUCCESS, 
          'info.recover_sent', 
          'info.recover_email', 
          'info.validity_period',
          'buttons.OK'
        ], { replaceUrl: true, queryParams: { email: this.forgotForm.value.email } });
      }

    }else{
      this.forgotForm.markAllAsTouched();
      this.forgotForm.updateValueAndValidity();
    }
  }

  cancel()  {
    history.back();
  }

  isFormInvalid(): boolean{
    return this.forgotForm.invalid;
  }

}
